export default (html) => {
  const script = '<script src="https://cdn.socket.io/4.1.2/socket.io.min.js"></script>'
  return html.replace('<head>', `<head> \n ${script}`)
}